import { concat, Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { PageOpenGenericErrorModal } from "../../redux/page/actions/default";

export const catchErrorWithDispatch =
    <Error$>(error$: (err?: any) => Observable<Error$>) =>
    <T>(source: Observable<T>): Observable<T> =>
        source.pipe(
            catchError((err) => {
                if (isTokenExpiredError(err)) {
                    handleApiError(err);
                    return error$(err);
                }
                return concat(
                    of(new PageOpenGenericErrorModal().create()),
                    error$(err)
                );
            })
        );

export const handleApiError = (apiError: any, windowObj: any = window) => {
    if (isTokenExpiredError(apiError)) {
        windowObj.location.href = process.env.PUBLIC_URL;
    }
};

export const isTokenExpiredError = (error: any) => {
    const { status, message } = error || {};
    const isUnauthorizedError = status === 401 || status === 429;
    const maybeIsCorsError =
        ["ajax error 0", "ajax error"].includes(message) &&
        [0, 500].includes(status) &&
        navigator.onLine;
    return isUnauthorizedError || maybeIsCorsError;
};
